<template>
<form class="pt-4">
    <div class="form-row">
        <div class="col-8">
            <form-input label="Filing ID" v-model="formData.filing_id" :errors="errors.filing_id" type="text" :maxlength="40" />
        </div>
        <div class="col-4" v-if="!disableUseForAll">
            <button class="btn btn-outline-primary" @click.prevent="$emit('set-jurisdiction-filing-id', {jurisdictionId: jurisdictionId, filingId: formData.filing_id})">Use for All</button>
        </div>
    </div>

    <form-input
        v-for="fieldDef in additionalFields"
        :key="fieldDef.name"
        :label="fieldDef.label"
        :required="fieldDef.hasOwnProperty('required') ? fieldDef.required : true"
        v-model="formData[fieldDef.name]"
        :errors="errors[fieldDef.name]"
        :type="fieldDef.type == 'rate' ? 'decimal' : fieldDef.widget"
        :options="fieldDef.type == 'boolean' ? [{text: 'Yes', value: true}, {text: 'No', value: false}] : fieldDef.options"
    />

    <form-input label="Exempt" v-model="formData.is_exempt" :errors="errors.is_exempt" type="radio" :options="[{text: 'Yes', value: true}, {text: 'No', value: false}]" />

    <form-errors :errors="formErrors" />
</form>
</template>

<script>
import FormMixin from '@/mixins/Form'

export default {
    props: ['taxId', 'jurisdictionId', 'taxType', 'additionalFields', 'value', 'disableUseForAll', ],
    mixins: [FormMixin, ],
    data() {
        const formRules = {
            filing_id: {presence: {allowEmpty: false}, },
            is_exempt: {presence: {allowEmpty: false}, },
        }

        const initialValue = this.value || {}
        const formData = {
            filing_id: initialValue.filing_id || '',
            is_exempt: initialValue.is_exempt || false,
        }

        this.additionalFields.forEach(af => {
            if (af.required) {
                formRules[af.name] = {presence: true }
            }

            formData[af.name] = initialValue[af.name] || ''
        })

        return {
            formData: formData,
            formRules: formRules,
            formLabels: {
                filing_id: 'Filing ID',
                is_exempt: 'Exempt',
            },
        }
    },
    methods: {
        setFilingId(filingId) {
            this.formData.filing_id = filingId
        },
        setErrors(errors) {
            Object.assign(this.errors, errors)
        },
        getFormData() {
            const data = JSON.parse(JSON.stringify(this.formData))
            this.additionalFields.forEach(af => {
                if (af.type == 'boolean') {
                    data[af.name] = (data[af.name] == 'true')
                }
            })

            return data
        },
    },
}

</script>
